export default __webpack_public_path__ + "f28790034bf67b0afb98db3b41b1d521.svg";